import React from "react"
import KEYBlue from "../common/keylist-blue"
type Props = {
  title: string
}

const HybridServices: React.FC<Props> = ({ title}) => {
  return (
    <section className="Development-Services section-py bg-grey">
      <div className="container lg:container mx-auto">
        <div className="row grid lg:grid-cols-12  justify-start items-center">
          <div className="lg:col-span-8">
            <div className="Development-Services-head text-start mb-5">
              <h2 className="fw-700 fs-xl">{title}</h2>
            </div>
          </div>
        </div>
        <div className="row grid lg:grid-cols-12 xl:grid-cols-12 md:grid-cols-12 gy-10">
          <div className="xl:col-span-6 lg:col-span-6 md:col-span-12">
            <div className="dev-service-inner">
              <p className="fs-md text-secondary mb-0 fw-400">
              We just don’t start with hybrid mobile app development. Instead, we plan, discuss, strategize and deploy best hybrid solutions that rule the world. With a squad of skilled and dedicated professionals that hold finest skills, knowledge, and abilities, we stand as one of the leading hybrid app development companies that develop solutions with the utmost refinement. Our list of offerings includes:
              </p>
            </div>
          </div>
          <div className="xl:col-span-3 lg:col-span-3 md:col-span-6">
            <div className="gap-5 ps-0 fs-md fw-500 flex flex-col reactjs-checkboxset">
            <KEYBlue text="Mobile Commerce" />
            <KEYBlue text="Marketing Apps" />
            <KEYBlue text="Gaming Consoles" />
            <KEYBlue text="Enterprise Mobility" />
            <KEYBlue text="E-learning Apps" />
            <KEYBlue text="Location-based Mobile Apps" />
            </div>
          </div>
          <div className="xl:col-span-3 lg:col-span-3 md:col-span-6">
            <div className="gap-5 ps-0 fs-md fw-500 flex flex-col reactjs-checkboxset">
            <KEYBlue text="Messaging Apps" />
            <KEYBlue text="Utility Apps" />
            <KEYBlue text="Media Apps" />
            <KEYBlue text="Healthcare & Fitness Apps" />
            <KEYBlue text="Social Networking Apps" />
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default HybridServices
